import { GET_TASKMAP_CHARTER, GET_TASK_CHARTER } from "./Charter/CharterType";
import {
  GET_TASKMAP_CORRESPONDENCE,
  GET_TASK_CORRESPONDENCE,
} from "./Correspondence/CorrespondenceType";
import {
  GET_TASKMAP_DOCUMENTS,
  GET_TASK_DOCUMENTS,
} from "./Documentation/DocumentationType";
import {
  GET_TASKMAP_MEETING_MINUTES,
  GET_TASK_MEETING_MINUTES,
} from "./MeetingMinutes/MeetingMinutesType";
import {
  CHANGE_TASKMAP_RESOURCE,
  GET_TASKMAP_RESOURCES,
  GET_TASKMAP_RESOURCES_BUYLIST,
  GET_TASK_RESOURCES,
  GET_TASK_RESOURCES_BUYLIST,
} from "./Resources/ResourcesType";
import {
  CHANGED_TASKMAP_PRIORITY_SOCKET,
  CHANGE_TASK_STATUS,
  Delete_TASK_CHANNEL_MESSAGE_SOCKET,
  EDITED_TASK_DEPENDENCY_SOCKET,
  EDITED_TASK_SOCKET,
  ENTER_IN_ARCHIVE_TASK_AA,
  GET_CHECKLIST_TASK,
  GET_CHECKLIST_TASKMAP,
  NEW_CHECKLIST_TASK_ADD,
  NEW_TASK_CHANNEL_MESSAGE_SOCKET,
  OUT_OF_ARCHIVE_TASK_AA,
  SOCKET_CHANGE_BNB,
  SET_TASK_EISENHOWER,
  SET_POMODORO_STATE,
  SOCKET_NEW_TASKMAP_WITH_CHILD,
  SOCKET_UPDATE_TASK,
  SOCKET_UPDATE_TASKMAP,
  SOCKET_UPDATE_TASKMAP_NOSTATUS,
  TASK_CHECKLIST_DELETE,
  TASK_CHECKLIST_ORDER_CHANGED,
  TASK_CHECKLIST_STATUS_CHANGED,
  FORM_ATTENTION_CHANGED,
  BOARD_ROOM_CHANGED,
  REACT_BOARD_CHANNEL_MESSAGE,
} from "./SocketTaskTypes";
import {
  OPEN_TASK,
  GET_TASKS_REQUEST,
  GET_TASKS_SUCCESS,
  GET_TASKMAPS_REQUEST,
  GET_TASKMAPS_SUCCESS,
  GET_TASKDESC_REQUEST,
  GET_TASKDESC_SUCCESS,
  GET_TASKMAPMEMBER_SUCCESS,
  GET_TASKMAPMEMBER_REQUEST,
  GET_BOARD_NAME_REQUEST,
  GET_BOARD_NAME_SUCCESS,
  TOGGLE_SHOW_BOARD_CHENNEL,
  ADMIN_PERMISSION_TASKMAPS,
  TOGGLE_SHOW_BOARD_TEAM,
  GET_BOARD_USERS_SUCCESS,
  ADD_NEW_BOARD_USERS_SUCCESS,
  TOGGLE_ADMIN_SUCCESS,
  REMOVE_TASKMAP_MEMBER_SUCCESS,
  REMOVE_BOARD_MEMBER_SUCCESS,
  EMPTY_NEW_REMOVED_MEMBER_MEMBER_STATE,
  NEW_TASK_SOCKET,
  BOARD_ADMIN_OWNER_CHECK,
  TOGGLE_SHOW_BOARD_SETTING,
  TOGGLE_SHOW_BOARD_AISTUDIO,
  GET_BOARD_SETTING,
  GET_BOARD_PANEL,
  GET_BOARD_COLUMNS,
  BOARD_TASK_LAYOUT,
  Delete_BOARD_COLUMN_SOCKET,
  GET_USER_RATES,
  USER_WORKING_TIME_ID,
  USER_ONLINE_TIME_ID,
  GET_USER_TIMES,
  REMOVED_TASK_SOCKET,
  USER_CONNECT_BOARDROOM,
  USER_LEAVE_BOARDROOM,
  GET_ONLINE_USERS,
  USER_WORKING_STATUS,
  TASKMAP_CHECKLIST_GET,
  NEW_CHECKLIST_TASKMAP_ADD,
  TASKMAP_CHECKLIST_ORDER_CHANGED,
  TASKMAP_CHECKLIST_DELETE,
  TASKMAP_CHECKLIST_STATUS_CHANGED,
  TOGGLE_SHOW_DAILY_REPORT,
  USER_DAILY_WORK_REPORTS,
  USER_RECENT_WORK_REPORTS,
  ADVOCACY_REVIEW_RUNS_SUCCESS,
  ADVOCACY_REVIEW_DAY_SUCCESS,
  SOCKET_DELETE_TASKMAP,
  SOCKET_NEW_TASKMAP,
  SOCKET_LEAVE_TASKMAP,
  IMPORT_TASKMAPS,
  ADD_USER_RATES,
  GET_TASKS_ARCHIVED_SUCCESS,
  TOGGLE_SHOW_BOARD_ARCHIVED_TASKS,
  GET_TASKS_ARCHIVED_REQUEST,
  PUSH_ARCHIVED_TASKS,
  RESET_ARCHIVED_TASKS,
  OUT_OF_ARCHIVE_TASK,
  ENTER_IN_ARCHIVE_TASK,
  CHANGE_CURRENT_USER_WORKING_STATUS,
  TOOGLE_SHOW_SCREEN_CHECK,
  RENAMED_TASK_SECCESS,
  NUMBER_FREE_JOINED_BOARD,
  BOARD_SIZE_LIMIT_SERVER,
  TOOGLE_SHOW_CALENDER_CHECK,
  CHANGE_TASK_DATES_SUSSECCFULLY,
  GANTT_TASKS,
  CHANGE_TASKMAP_DATE_GANTT,
  UPDATE_TASKMAP_TASKDETAIL_GANTT,
  BOARD_MENU_MODEL,
  TOGGLE_SHOW_BOARD_FINANCIAL,
  GET_BOARD_FINANCIAL,
  FINANCIAL_CATEGORY_CHANGE,
  FINANCIAL_PAYMENT_CATEGORY_CHANGE,
  FINANCIAL_SETTINGS_CHANGE,
  FINANCIAL_BUDGET_CHANGE,
  FINANCIAL_CATEGORIES,
  ADD_UPLOAD,
  DELETE_UPLOAD,
  UPDATED_FINANTIAL_PAYMENT,
  NEW_FINANTIAL_PAYMENT,
  DELETE_FINANTIAL_PAYMENT,
  DELETE_ALL_UPLOAD,
  DELETE_MULTI_VOICE_UPLOAD,
  FINANTIAL_DUE_PERCENTAGE_CHANGE,
  NEW_FINANTIAL_DUE_PERCENTAGE,
  ADD_FINANTIAL_PAYMENT,
  GET_TASK_PAYMENTS_SUCCESS,
  ADD_FINANTIAL_PAYMENT_TASKMAP,
  CHANGE_FINANTIAL_PAYMENT_TASK,
  CHANGE_FINANTIAL_PAYMENT_TASKMAP,
  GET_BOARD_FINANCIAL_PAYMENTS,
  GET_BOARD_FINANCIAL_PAYMENTS_TASKS,
  DELETE_FINANTIAL_PAYMENT_TASK,
  DELETE_FINANTIAL_PAYMENT_TASKMAP,
  DELETE_FINANTIAL_PAYMENT_TASK_ALL,
  DELETE_FINANTIAL_PAYMENT_TASKMAP_ALL,
  CHANGE_FINANTIAL_PAYMENT_TASK_ALL,
  CHANGE_FINANTIAL_PAYMENT_TASKMAP_ALL,
  TOGGLE_SHOW_CRM,
  TOGGLE_SHOW_CRISIS,
  NEW_CATEGORY_TASK,
  TASKS_FILTERS_DATA,
  SPRINT_FILTERS_DATA,
  CHANGED_TASK_VALUE,
  CHANGED_TASK_COMPLETE_STATUS,
  GET_USER_BOARD_GROUPS,
  GET_BOARD_GROUPS,
  ADD_BOARD_GROUPS,
  EDIT_BOARD_GROUP,
  DELETE_BOARD_GROUP,
  TOGGLE_SHOW_REMINDER,
  TOGGLE_SHOW_BOARD_HABITS,
  GET_BOARD_REMINDER,
  NEW_BOARD_REMINDER,
  EDIT_BOARD_REMINDER,
  DELETE_BOARD_REMINDER,
  NEW_BOARD_TASK_REMINDER,
  GET_BOARD_TASKS_REMINDERS,
  GET_BOARD_TASK_REMINDERS,
  NEW_BOARD_TASKMAP_REMINDER,
  EDIT_BOARD_TASK_REMINDER,
  DELETE_BOARD_TASK_REMINDER,
  EDIT_BOARD_TASKMAP_REMINDER,
  DELETE_BOARD_TASKMAP_REMINDER,
  DISCOUNT_CODE_CHECK,
  NEW_USER_DISCOUNT_STATUS,
  GET_USER_TASKS,
  TASKS_SHOW_ALL_FILTER,
  CHANGE_UPLOAD_WORKED_SCREEN_STATUS,
  BOARD_PERMISSIONS,
  UG_PERMISSIONS,
  TOGGLE_SHOW_BOARD_CHARTER,
  TOOGLE_SHOW_WBS_CHECK,
  TOGGLE_SHOW_BOARD_WHITE_SPACE,
  TOGGLE_SHOW_BOARD_FLOW_CHART,
  EDIT_BOARD_MEMBER_SUCCESS,
  TASKS_SHOW_DETAIL_TOGGLE,
  TASKS_VIEW_MODEL,
  REQUEST_OPEN_TASK_DETAIL,
  TOGGLE_FULLSCREEN_CALENDAR,
  GET_BOARD_AUTOMATIONS_SUCCESS,
  GET_BOARD_GENERAL_DATA,
  CALENDAR_SHOW_LOOP_TASKS,
  TOGGLE_SHOW_BOARD_DOCUMENTATION,
  TOGGLE_SHOW_BOARD_ADVOCACY_REVIEW,
  SET_SHOW_BOARD_ADVOCACY_REVIEW,
  TOGGLE_SHOW_BOARD_FORM,
  GET_BOARD_WORK_SETTING,
  TOGGLE_SHOW_BOARD_RESOURCES,
  TOGGLE_SHOW_BOARD_MEETING_MINUTE,
  TOGGLE_SHOW_BOARD_CORRESPONDENCE,
  EDIT_TASKMAP_MESSAGE,
  GET_BOARDTEMPORARY_GOALS,
  GET_TASK_TEMPORARY_GOALS,
  GET_BOARD_TASK_CHANNEL_MESSAGES,
  EDIT_TASK_MESSAGE,
  GET_TASK_MEMBER_SUCCESS,
  CHANGE_TASK_DATE_GANTT,
  UPDATE_TASK_TASKDETAIL_GANTT,
  TOOGLE_SHOW_SPRINT_MOOD,
  SPRINT_MOOD_DATA,
  BOARD_PIC,
  SET_CALENDAR_ACTIVE_TIME,
  SET_CALENDAR_SHOWING_MOOD,
  PUSH_NEW_TASKS,
  GET_TASKMAPS_PROGRESS_CHART_DATA,
  GET_PROGRESS_CHART_DATA,
  EDIT_TASK_CURRENT_DOING,
  GET_TASK_CURRENT_DOING,
  GET_TASK_MAP_CURRENT_DOING,
  UPDATE_TASK_MAP_CURRENT_DOING,
  SET_UPLOADS,
  REPLACE_VOICE_DESC_IN_TASK,
  GET_BOARD_SUBTASKS_COUNT_REQUEST,
  GET_BOARD_SUBTASKS_COUNT_SUCCESS,
  GET_BOARD_HISTORY,
  GET_BOARD_USER_HISTORY,
  REPLACE_DESC_DATA_IN_TASKMAP,
  TASKS_SEARCH_TEXT,
  SET_SHOWING_COS_ID,
  GET_SINGLE_TASK_SUCCESS,
  TASK_CHANNEL_LOAD_OLDER_REQUEST,
  TASK_CHANNEL_LOAD_OLDER_SUCCESS,
  TASK_CHANNEL_LOAD_OLDER_FAIL,
} from "./TasksType";

export const TasksStateReducer = (
  state = {
    Loading: true,
    data: [],
    gantt: [],
    UserTasks: [],
    WhichOpen: undefined,
    pendingOpenTaskDetailId: undefined,
    subTasksCount: 0,
    socketSignals: {},
    taskChatPaginationByTaskId: {},
    loadingOlderTaskChatByTaskId: {},
    _pendingTaskChats: {},
  },
  action,
) => {
  switch (action.type) {
    case GET_TASKS_REQUEST: {
      return {
        ...state,
        Loading: true,
        data: [],
      };
    }
    case GET_TASKS_SUCCESS: {
      return {
        ...state,
        Loading: false,
        data: action.Payload,
      };
    }
    case GET_USER_TASKS: {
      return {
        ...state,
        UserTasks: action.Payload,
      };
    }
    case RENAMED_TASK_SECCESS: {
      const idx = state.data.findIndex(
        (item) => item._id === action.Payload._id,
      );
      if (idx < 0) return state;
      const data = [...state.data];
      data[idx] = { ...data[idx], TaskName: action.Payload.TaskName };
      return {
        ...state,
        Loading: false,
        data,
      };
    }

    case EDITED_TASK_DEPENDENCY_SOCKET: {
      const idx = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (idx < 0) {
        return state;
      }
      const data = [...state.data];
      data[idx] = { ...data[idx], Dependency: action.Payload.Dependency };
      return {
        ...state,
        Loading: false,
        data,
      };
    }

    case EDITED_TASK_SOCKET: {
      let Tasks = state.data;

      const Task7InArraynum = Tasks.findIndex(
        (item) => item._id === action.Payload._id,
      );
      if (Task7InArraynum < 0) {
        return state;
      }
      const prevTask = Tasks[Task7InArraynum];
      const nextTask = {
        ...action.Payload,
        Open: prevTask?.Open,
        Creator:
          action.Payload.Creator !== undefined
            ? action.Payload.Creator
            : prevTask?.Creator,
      };
      const data = [...Tasks];
      data[Task7InArraynum] = nextTask;
      return {
        ...state,
        Loading: false,
        data,
      };
    }

    case GET_SINGLE_TASK_SUCCESS: {
      const payload = action.Payload;
      if (!payload) return state;

      const taskToUpdate = Array.isArray(payload)
        ? payload.find((t) => t?._id)
        : payload;
      if (!taskToUpdate?._id) return state;

      const idx = state.data.findIndex((t) => t?._id === taskToUpdate._id);

      // Realtime path: an archived/deleted task must leave the visible list
      // (kanban renders state.data unfiltered by IsArchive); a task the list
      // lacks — created or unarchived by another client — gets appended.
      if (taskToUpdate.IsArchive || taskToUpdate.Deleted) {
        if (idx < 0) return state;
        return {
          ...state,
          data: state.data.filter((t) => t?._id !== taskToUpdate._id),
        };
      }
      if (idx < 0) return { ...state, data: [...state.data, taskToUpdate] };

      const tasks = [...state.data];
      tasks[idx] = taskToUpdate;
      return { ...state, data: tasks };
    }

    case REPLACE_VOICE_DESC_IN_TASK: {
      const taskId = action?.Payload?.TaskID;
      if (!taskId) return state;

      const nextData = state.data.map((task) => {
        if (task?._id !== taskId) return task;

        // Backend response may include VoiceDescUrls and/or VoiceDesc
        const nextTask = { ...task };
        if (action?.Payload?.VoiceDesc !== undefined) {
          nextTask.VoiceDesc = action.Payload.VoiceDesc;
        }
        if (action?.Payload?.VoiceDescUrls !== undefined) {
          nextTask.VoiceDescUrls = action.Payload.VoiceDescUrls;
        }

        // VoiceDescs,
        // VideoDescs,

        if (action?.Payload?.VoiceDescs !== undefined) {
          nextTask.VoiceDescs = action.Payload.VoiceDescs;
        }

        if (action?.Payload?.VideoDescs !== undefined) {
          nextTask.VideoDescs = action.Payload.VideoDescs;
        }

        return nextTask;
      });

      return {
        ...state,
        data: nextData,
      };
    }

    case SOCKET_CHANGE_BNB: {
      const Tasks8 = state.data;
      const TasksSocket8 = action.Payload;
      const byId = new Map(TasksSocket8.map((t) => [t._id, t]));
      let changed = false;

      const data = Tasks8.map((task) => {
        const s = byId.get(task._id);
        if (!s) return task;
        changed = true;
        return {
          ...task,
          Column: s.Column,
          ColumnID: s.ColumnID,
          SprintID: s.SprintID,
          Priority: s.Priority,
          TableListPriority: s.TableListPriority,
          SprintPriority: s.SprintPriority,
        };
      });

      return changed ? { ...state, data } : state;
    }
    case CHANGED_TASK_VALUE: {
      const idx = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (idx < 0) return state;
      const data = [...state.data];
      data[idx] = { ...data[idx], TaskValue: action.Payload.TaskValue };
      return {
        ...state,
        Loading: false,
        data,
      };
    }
    case CHANGE_TASK_DATES_SUSSECCFULLY: {
      const idx = state.data.findIndex(
        (item) => item._id === action.Payload._id,
      );
      if (idx < 0) return state;
      const payload = action.Payload;
      const patch =
        payload.Loop !== undefined
          ? {
              Loop: payload.Loop,
              LoopTimeData: payload.LoopTimeData ?? {},
              Start: undefined,
              End: undefined,
            }
          : {
              Start: payload.Start,
              End: payload.End,
              ...(payload.ManuallyTimeDuration !== undefined
                ? { ManuallyTimeDuration: payload.ManuallyTimeDuration }
                : {}),
            };
      const data = [...state.data];
      data[idx] = { ...data[idx], ...patch };
      return {
        ...state,
        Loading: false,
        data,
      };
    }
    case ENTER_IN_ARCHIVE_TASK: {
      let Tasks = state.data;
      Tasks = Tasks.filter((item) => item._id !== action.Payload._id);
      return {
        ...state,
        data: Tasks,
      };
    }
    case REMOVED_TASK_SOCKET: {
      const isRemoved = (item) => item._id !== action.Payload;
      return {
        ...state,
        data: state.data.filter(isRemoved),
        // The gantt slice feeds the WBS board view too — a deleted task must
        // disappear from the graph immediately (same for other clients).
        gantt: Array.isArray(state.gantt)
          ? state.gantt.filter(isRemoved)
          : state.gantt,
      };
    }
    case OUT_OF_ARCHIVE_TASK: {
      return {
        ...state,
        data: [...state.data, action.Payload],
      };
    }
    case REQUEST_OPEN_TASK_DETAIL: {
      // BoardTaskDetailHost owns task detail now; clear the legacy card-modal
      // flags (task.Open / WhichOpen) so a stale card-embedded TaskDetail can
      // never stay mounted underneath the hosted one.
      const hasOpenFlag = state.data.some((item) => item.Open);
      return {
        ...state,
        pendingOpenTaskDetailId: action.Payload,
        WhichOpen: undefined,
        data: hasOpenFlag
          ? state.data.map((item) =>
              item.Open ? { ...item, Open: false } : item,
            )
          : state.data,
      };
    }
    case OPEN_TASK: {
      const taskId = action.Payload?._id;
      if (!taskId) return state;

      const isCurrentlyOpen = state.WhichOpen === taskId;
      if (isCurrentlyOpen) {
        const data12 = state.data.map((item) =>
          item._id === taskId ? { ...item, Open: false } : item,
        );
        return { ...state, WhichOpen: undefined, data: data12 };
      }

      const data12 = state.data.map((item) => {
        if (item._id === taskId) return { ...item, Open: true };
        if (item.Open) return { ...item, Open: false };
        return item;
      });

      return {
        ...state,
        WhichOpen: taskId,
        data: data12,
      };
    }
    case NEW_TASK_SOCKET: {
      return {
        ...state,
        Loading: false,
        data: [...state.data, action.Payload],
      };
    }
    case PUSH_NEW_TASKS: {
      const existingIds = new Set(
        state.data.map((task) => task._id.toString()),
      );
      const newTasks = action.Payload.filter(
        (task) => !existingIds.has(task._id.toString()),
      );
      const merged = [...state.data, ...newTasks];
      if (state._pendingTaskChats) {
        for (const task of merged) {
          const pending = state._pendingTaskChats[task._id];
          if (pending) {
            task.TaskChat = pending;
          }
        }
      }
      return {
        ...state,
        Loading: false,
        data: merged,
      };
    }
    case GET_BOARD_SUBTASKS_COUNT_REQUEST: {
      return {
        ...state,
        Loading: true,
      };
    }
    case GET_BOARD_SUBTASKS_COUNT_SUCCESS: {
      return {
        ...state,
        Loading: false,
        subTasksCount: action.Payload,
      };
    }
    // به‌روزرسانی تعداد ساب‌تسک‌ها هنگام اضافه شدن ساب‌تسک جدید
    case SOCKET_NEW_TASKMAP: {
      // اگر ساب‌تسک جدید آرشیو یا حذف شده نیست، تعداد را افزایش می‌دهیم
      if (
        action.Payload &&
        !action.Payload.IsArchive &&
        !action.Payload.Deleted
      ) {
        return {
          ...state,
          subTasksCount: state.subTasksCount + 1,
        };
      }
      return state;
    }
    // به‌روزرسانی تعداد ساب‌تسک‌ها هنگام اضافه شدن ساب‌تسک با child
    case SOCKET_NEW_TASKMAP_WITH_CHILD: {
      // اگر ساب‌تسک child جدید آرشیو یا حذف شده نیست، تعداد را افزایش می‌دهیم
      if (
        action.Payload?.ChildBody &&
        !action.Payload.ChildBody.IsArchive &&
        !action.Payload.ChildBody.Deleted
      ) {
        return {
          ...state,
          subTasksCount: state.subTasksCount + 1,
        };
      }
      return state;
    }
    // به‌روزرسانی تعداد ساب‌تسک‌ها هنگام حذف شدن ساب‌تسک
    case SOCKET_DELETE_TASKMAP: {
      // وقتی ساب‌تسک حذف می‌شود، باید دوباره محاسبه کنیم
      // اما چون نمی‌دانیم که آیا این ساب‌تسک آرشیو بود یا نه،
      // بهتر است که دوباره از API بگیریم
      // برای حال حاضر، فقط یک واحد کاهش می‌دهیم (اگر مثبت باشد)
      return {
        ...state,
        subTasksCount: Math.max(0, state.subTasksCount - 1),
      };
    }
    case GANTT_TASKS: {
      return { ...state, gantt: action.Payload };
    }
    case CHANGE_TASKMAP_DATE_GANTT: {
      const Tasks3 = state.gantt;
      const findIndexOfTask3 = Tasks3.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (findIndexOfTask3 < 0) return state;
      const taskMap = Tasks3[findIndexOfTask3].TaskMap;
      const findIndexOfTaskMap3 = taskMap.findIndex(
        (item) => item._id === action.Payload.TaskMapID,
      );
      if (findIndexOfTaskMap3 < 0) return state;
      const nextTaskMap = [...taskMap];
      nextTaskMap[findIndexOfTaskMap3] = {
        ...taskMap[findIndexOfTaskMap3],
        DeadLine: action.Payload.body.DeadLine,
        StartTime: action.Payload.body.StartTime,
      };
      const gantt = [...Tasks3];
      gantt[findIndexOfTask3] = {
        ...Tasks3[findIndexOfTask3],
        TaskMap: nextTaskMap,
      };
      return { ...state, gantt };
    }
    case CHANGE_TASK_DATE_GANTT: {
      const findIndexOfTask22 = state.gantt.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (findIndexOfTask22 < 0) return state;
      const gantt = [...state.gantt];
      gantt[findIndexOfTask22] = {
        ...gantt[findIndexOfTask22],
        End: action.Payload.body.End,
        Start: action.Payload.body.Start,
      };
      return { ...state, gantt };
    }
    case UPDATE_TASK_TASKDETAIL_GANTT: {
      const indexOfTask23 = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOfTask23 < 0) return state;
      const data = [...state.data];
      data[indexOfTask23] = {
        ...data[indexOfTask23],
        End: action.Payload.body.End,
        Start: action.Payload.body.Start,
      };
      return { ...state, data };
    }
    case SET_TASK_EISENHOWER: {
      const eisenhowerIdx = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (eisenhowerIdx < 0) return state;
      const data = [...state.data];
      data[eisenhowerIdx] = {
        ...data[eisenhowerIdx],
        Eisenhower: action.Payload.Eisenhower,
      };
      return { ...state, data };
    }
    case CHANGE_TASK_STATUS: {
      const Tasks4 = [...state.data];
      const payload = action.Payload || {};
      const { TaskID, Status, data: taskData } = payload;

      if (!TaskID) return state;

      const indexOFFindTask4 = Tasks4.findIndex((item) => item._id === TaskID);
      if (indexOFFindTask4 === -1) return state;

      const currentTask = Tasks4[indexOFFindTask4];

      let nextTask = currentTask;

      if (taskData && typeof taskData === "object") {
        const statusObj =
          taskData.Status &&
          typeof taskData.Status === "object" &&
          !Array.isArray(taskData.Status)
            ? taskData.Status
            : currentTask.Status;

        const tStatus =
          taskData.TaskStatus ??
          (Status && Status !== "" ? Status : currentTask.TaskStatus);

        nextTask = {
          ...currentTask,
          ...taskData,
          Status: statusObj,
          TaskStatus: tStatus,
        };
      } else {
        const nextStatus = Status ?? currentTask.TaskStatus;
        nextTask = {
          ...currentTask,
          TaskStatus: nextStatus,
          ...(nextStatus === "Complete" ? { Complete: true } : {}),
        };
      }

      Tasks4[indexOFFindTask4] = nextTask;

      return { ...state, data: Tasks4 };
    }
    case CHANGED_TASK_COMPLETE_STATUS: {
      const indexOFFindTask6 = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOFFindTask6 < 0) return state;
      const data = [...state.data];
      data[indexOFFindTask6] = {
        ...data[indexOFFindTask6],
        Complete: action.Payload.Complete,
      };
      return { ...state, data };
    }
    case GET_TASK_CHARTER: {
      const TaskID = action.Payload.TaskID;
      const indexOFFindTask9 = state.data.findIndex(
        (item) => String(item._id) === String(TaskID),
      );
      if (indexOFFindTask9 === -1) return state;

      const Tasks9 = [...state.data];
      Tasks9[indexOFFindTask9] = {
        ...Tasks9[indexOFFindTask9],
        Charter: action.Payload.Charter,
      };
      return { ...state, data: Tasks9 };
    }
    case GET_TASK_DOCUMENTS: {
      const indexOFFindTask10 = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOFFindTask10 < 0) return state;
      const data = [...state.data];
      data[indexOFFindTask10] = {
        ...data[indexOFFindTask10],
        Documents: action.Payload.Documents,
      };
      return { ...state, data };
    }
    case GET_TASK_MEETING_MINUTES: {
      const indexOFFindTask11 = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOFFindTask11 < 0) return state;
      const data = [...state.data];
      data[indexOFFindTask11] = {
        ...data[indexOFFindTask11],
        MeetingMinutes: action.Payload.MeetingMinutes,
      };
      return { ...state, data };
    }
    case GET_TASK_CORRESPONDENCE: {
      const indexOFFindTask12 = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOFFindTask12 < 0) return state;
      const data = [...state.data];
      data[indexOFFindTask12] = {
        ...data[indexOFFindTask12],
        Correspondences: action.Payload.Correspondences,
      };
      return { ...state, data };
    }
    case GET_TASK_TEMPORARY_GOALS: {
      const indexOFTask13 = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOFTask13 < 0) return state;
      const data = [...state.data];
      data[indexOFTask13] = {
        ...data[indexOFTask13],
        TemporaryGoals: action.Payload.data,
      };
      return { ...state, data };
    }
    case NEW_CHECKLIST_TASK_ADD: {
      const indexOfTask14 = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOfTask14 < 0) return state;
      const data = [...state.data];
      data[indexOfTask14] = {
        ...data[indexOfTask14],
        TaskChecklist: [
          ...(data[indexOfTask14].TaskChecklist || []),
          action.Payload.body,
        ],
      };
      return { ...state, data };
    }
    case GET_CHECKLIST_TASK:
    case TASK_CHECKLIST_ORDER_CHANGED:
    case TASK_CHECKLIST_DELETE:
    case TASK_CHECKLIST_STATUS_CHANGED: {
      const indexOfTask = state.data.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOfTask < 0) return state;
      const data = [...state.data];
      data[indexOfTask] = {
        ...data[indexOfTask],
        TaskChecklist: action.Payload.body,
      };
      return { ...state, data };
    }
    case NEW_TASK_CHANNEL_MESSAGE_SOCKET: {
      const payloadData = action.Payload.data;
      const taskID = action.Payload.TaskID;
      if (payloadData._replaceTempId) {
        const Task18 = state.data.map((item) => {
          if (item._id !== taskID) return item;
          const chat = item.TaskChat || [];
          const idx = chat.findIndex(
            (m) => String(m._id) === String(payloadData._replaceTempId),
          );
          if (idx >= 0) {
            const clean = { ...payloadData };
            delete clean._replaceTempId;
            const newChat = [...chat];
            newChat[idx] = clean;
            return { ...item, TaskChat: newChat };
          }
          return item;
        });
        return { ...state, data: Task18 };
      }
      if (payloadData._markFailedId) {
        const Task18 = state.data.map((item) => {
          if (item._id !== taskID) return item;
          const chat = (item.TaskChat || []).map((m) =>
            String(m._id) === String(payloadData._markFailedId)
              ? {
                  ...m,
                  _status: "failed",
                  _errorMessage: payloadData._errorMessage,
                }
              : m,
          );
          return { ...item, TaskChat: chat };
        });
        return { ...state, data: Task18 };
      }
      const Task18 = state.data.map((item) =>
        item._id === taskID
          ? { ...item, TaskChat: [...(item.TaskChat || []), payloadData] }
          : item,
      );
      return { ...state, data: Task18 };
    }
    case REACT_BOARD_CHANNEL_MESSAGE: {
      const { MessageID, TaskID, reactions } = action.Payload ?? {};
      if (!TaskID) return state;
      const nextData = state.data.map((item) => {
        if (String(item._id) !== String(TaskID)) return item;
        const chat = (item.TaskChat || []).map((m) =>
          String(m._id) === String(MessageID)
            ? { ...m, Reactions: reactions }
            : m,
        );
        return { ...item, TaskChat: chat };
      });
      return { ...state, data: nextData };
    }
    case GET_BOARD_TASK_CHANNEL_MESSAGES: {
      const Task19 = [...state.data];
      const indexOfTask19 = Task19.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      const messagesPagination = action.Payload.messagesPagination ?? null;
      const nextPaginationByTaskId = {
        ...state.taskChatPaginationByTaskId,
        [action.Payload.TaskID]: messagesPagination,
      };
      if (indexOfTask19 === -1) {
        return {
          ...state,
          taskChatPaginationByTaskId: nextPaginationByTaskId,
          _pendingTaskChats: {
            ...state._pendingTaskChats,
            [action.Payload.TaskID]: action.Payload.data,
          },
        };
      }
      Task19[indexOfTask19] = {
        ...Task19[indexOfTask19],
        TaskChat: action.Payload.data,
      };
      return {
        ...state,
        data: Task19,
        taskChatPaginationByTaskId: nextPaginationByTaskId,
      };
    }
    case TASK_CHANNEL_LOAD_OLDER_REQUEST: {
      const TaskID = action.Payload?.TaskID;
      if (!TaskID) return state;
      return {
        ...state,
        loadingOlderTaskChatByTaskId: {
          ...state.loadingOlderTaskChatByTaskId,
          [TaskID]: true,
        },
      };
    }
    case TASK_CHANNEL_LOAD_OLDER_SUCCESS: {
      const {
        TaskID,
        data: olderMessages,
        messagesPagination,
      } = action.Payload ?? {};
      const Task19 = [...state.data];
      const indexOfTask19 = Task19.findIndex((item) => item._id === TaskID);
      const nextPaginationByTaskId = {
        ...state.taskChatPaginationByTaskId,
        [TaskID]:
          messagesPagination ?? state.taskChatPaginationByTaskId[TaskID],
      };
      const nextLoadingByTaskId = {
        ...state.loadingOlderTaskChatByTaskId,
        [TaskID]: false,
      };
      if (indexOfTask19 === -1) {
        return {
          ...state,
          taskChatPaginationByTaskId: nextPaginationByTaskId,
          loadingOlderTaskChatByTaskId: nextLoadingByTaskId,
        };
      }
      const existingTaskChat = Task19[indexOfTask19]?.TaskChat ?? [];
      const existingIds = new Set(existingTaskChat.map((m) => String(m._id)));
      const dedupedOlder = (olderMessages ?? []).filter(
        (m) => !existingIds.has(String(m._id)),
      );
      Task19[indexOfTask19] = {
        ...Task19[indexOfTask19],
        TaskChat: [...dedupedOlder, ...existingTaskChat],
      };
      return {
        ...state,
        data: Task19,
        taskChatPaginationByTaskId: nextPaginationByTaskId,
        loadingOlderTaskChatByTaskId: nextLoadingByTaskId,
      };
    }
    case TASK_CHANNEL_LOAD_OLDER_FAIL: {
      const TaskID = action.TaskID;
      if (!TaskID) return state;
      return {
        ...state,
        loadingOlderTaskChatByTaskId: {
          ...state.loadingOlderTaskChatByTaskId,
          [TaskID]: false,
        },
      };
    }
    case Delete_TASK_CHANNEL_MESSAGE_SOCKET: {
      const Task20 = state.data;
      const indexOfTask20 = Task20.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOfTask20 < 0) return state;
      const data20 = [...Task20];
      data20[indexOfTask20] = {
        ...data20[indexOfTask20],
        TaskChat: (data20[indexOfTask20].TaskChat || []).filter(
          (item) => item._id !== action.Payload.body,
        ),
      };
      return { ...state, data: data20 };
    }
    case EDIT_TASK_MESSAGE: {
      const Task21 = state.data;
      const indexOfTask21 = Task21.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOfTask21 < 0) return state;
      const data21 = [...Task21];
      data21[indexOfTask21] = {
        ...data21[indexOfTask21],
        TaskChat: (data21[indexOfTask21].TaskChat || []).map((item) =>
          item._id === action.Payload.body._id ? action.Payload.body : item,
        ),
      };
      return { ...state, data: data21 };
    }
    case GET_TASK_MEMBER_SUCCESS: {
      const data = state.data || [];
      const indexOfTask22 = data.findIndex(
        (item) => item && item._id === action.Payload.TaskID,
      );
      if (indexOfTask22 === -1) return state;

      const nextTask = {
        ...data[indexOfTask22],
        TaskMembers: action.Payload.data,
      };
      const nextData = [...data];
      nextData[indexOfTask22] = nextTask;

      return { ...state, data: nextData };
    }
    case GET_TASK_RESOURCES_BUYLIST: {
      const Task24 = state.data;
      const indexOfTask24 = Task24.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOfTask24 < 0) return state;
      const data24 = [...Task24];
      data24[indexOfTask24] = {
        ...data24[indexOfTask24],
        TaskResourcesBuyLists: action.Payload.ResourcesBuyLists,
      };
      return { ...state, data: data24 };
    }
    case GET_TASK_RESOURCES: {
      const Task25 = state.data;
      const indexOfTask25 = Task25.findIndex(
        (item) => item._id === action.Payload.TaskID,
      );
      if (indexOfTask25 < 0) return state;
      const data25 = [...Task25];
      data25[indexOfTask25] = {
        ...data25[indexOfTask25],
        TaskResources: action.Payload.Resources,
      };
      return { ...state, data: data25 };
    }
    case GET_TASKDESC_SUCCESS: {
      const Task27 = state.data;
      const indexOfTask27 = Task27.findIndex(
        (item) => item._id === action.TaskID,
      );
      if (indexOfTask27 < 0) return state;
      const data27 = [...Task27];
      data27[indexOfTask27] = {
        ...data27[indexOfTask27],
        Desc: action.Payload,
      };
      return { ...state, data: data27 };
    }
    default: {
      return state;
    }
  }
};
export const TasksStateArchivedReducer = (
  state = { ArchivedTasks: [], hasMore: true, queryKey: null },
  action,
) => {
  switch (action.type) {
    case GET_TASKS_ARCHIVED_REQUEST: {
      return { ...state, ArchivedTasks: [], hasMore: true };
    }
    case GET_TASKS_ARCHIVED_SUCCESS: {
      const { tasks, hasMore } = action.Payload;
      return { ...state, ArchivedTasks: tasks, hasMore: hasMore ?? false };
    }
    case RESET_ARCHIVED_TASKS: {
      const { tasks, hasMore, queryKey } = action.Payload;
      return {
        ...state,
        ArchivedTasks: tasks,
        hasMore: hasMore ?? false,
        queryKey: queryKey ?? null,
      };
    }
    case PUSH_ARCHIVED_TASKS: {
      const { tasks, hasMore, queryKey } = action.Payload;
      if (
        queryKey != null &&
        state.queryKey != null &&
        queryKey !== state.queryKey
      ) {
        return state;
      }
      const existingIds = new Set(
        state.ArchivedTasks.map((t) => t._id?.toString()),
      );
      const newTasks = (tasks || []).filter(
        (t) => !existingIds.has(t._id?.toString()),
      );
      return {
        ...state,
        ArchivedTasks: [...state.ArchivedTasks, ...newTasks],
        hasMore: hasMore ?? false,
      };
    }
    case ENTER_IN_ARCHIVE_TASK_AA: {
      return {
        ...state,
        ArchivedTasks: [...state.ArchivedTasks, action.Payload],
      };
    }
    case OUT_OF_ARCHIVE_TASK_AA: {
      let arr = state.ArchivedTasks;
      arr = arr.filter((item) => item._id !== action.Payload._id);

      return {
        ...state,
        ArchivedTasks: arr,
      };
    }
    default: {
      return state;
    }
  }
};

// Immutable helpers for the TaskMaps state — replace only the touched taskmap
// object so untouched entries keep their reference (React.memo stays valid).
const patchTaskMap = (state, taskMapId, patch) => {
  const idx = state.TaskMaps.findIndex((tm) => tm._id === taskMapId);
  if (idx < 0) return state;
  const TaskMaps = [...state.TaskMaps];
  TaskMaps[idx] = { ...TaskMaps[idx], ...patch };
  return { ...state, TaskMaps };
};

const pushTaskMapList = (state, taskMapId, listKey, item) => {
  const tm = state.TaskMaps.find((m) => m._id === taskMapId);
  if (!tm) return state;
  return patchTaskMap(state, taskMapId, {
    [listKey]: [...(tm[listKey] || []), item],
  });
};

const replaceInTaskMapList = (state, taskMapId, listKey, item) => {
  const tm = state.TaskMaps.find((m) => m._id === taskMapId);
  if (!tm) return state;
  const list = tm[listKey] || [];
  const idx = list.findIndex((x) => x._id === item._id);
  if (idx < 0) return state;
  const next = [...list];
  next[idx] = item;
  return patchTaskMap(state, taskMapId, { [listKey]: next });
};

const removeFromTaskMapList = (state, taskMapId, listKey, predicate) => {
  const tm = state.TaskMaps.find((m) => m._id === taskMapId);
  if (!tm) return state;
  return patchTaskMap(state, taskMapId, {
    [listKey]: (tm[listKey] || []).filter(predicate),
  });
};

export const GetTaskMapReducer = (state = { TaskMaps: [] }, action) => {
  switch (action.type) {
    case GET_TASKMAPS_REQUEST: {
      return { ...state, Loading: true, TaskMaps: [], lastLoadedTaskId: null };
    }
    case GET_TASKMAPS_SUCCESS: {
      const p = action.Payload;
      const taskMaps = Array.isArray(p) ? p : p.taskMaps;
      const taskId = Array.isArray(p) ? undefined : p.taskId;
      return {
        ...state,
        Loading: false,
        TaskMaps: taskMaps ?? [],
        lastLoadedTaskId:
          taskId != null ? String(taskId) : state.lastLoadedTaskId,
      };
    }

    case REPLACE_DESC_DATA_IN_TASKMAP: {
      // const taskId = action?.Payload?.TaskID;
      const taskMapID = action?.Payload?.TaskMapID;
      if (!taskMapID) return state;

      const nextData = state.TaskMaps.map((task) => {
        if (task?._id !== taskMapID) return task;

        // Backend response may include VoiceDescUrls and/or VoiceDesc
        const nextTask = { ...task };
        if (action?.Payload?.VoiceDesc !== undefined) {
          nextTask.VoiceDesc = action.Payload.VoiceDesc;
        }
        if (action?.Payload?.VoiceDescUrls !== undefined) {
          nextTask.VoiceDescUrls = action.Payload.VoiceDescUrls;
        }

        if (action?.Payload?.TaskMapDescription !== undefined) {
          nextTask.TaskMapDescription = action.Payload.TaskMapDescription;
        }

        // VoiceDescs,
        // VideoDescs,

        if (action?.Payload?.VoiceDescs !== undefined) {
          nextTask.VoiceDescs = action.Payload.VoiceDescs;
        }

        if (action?.Payload?.VideoDescs !== undefined) {
          nextTask.VideoDescs = action.Payload.VideoDescs;
        }

        return nextTask;
      });

      return {
        ...state,
        TaskMaps: nextData,
      };
    }

    case SOCKET_DELETE_TASKMAP: {
      const Tasks = state.TaskMaps;
      const DeletedArr = Tasks.filter((e) => e._id !== action.Payload);
      return { Loading: false, TaskMaps: DeletedArr };
    }
    case SOCKET_UPDATE_TASKMAP: {
      if (state.TaskMaps.length === 0) return { ...state, TaskMaps: [] };
      let TaskMaps5 = state.TaskMaps;
      const FindTaskMap5 = TaskMaps5.filter(
        (item) => item._id === action.Payload.data._id,
      );
      const FindTaskMap5Index = TaskMaps5.indexOf(FindTaskMap5[0]);
      TaskMaps5[FindTaskMap5Index] = action.Payload.data;
      return { ...state, TaskMaps: [...TaskMaps5] };
    }
    case SOCKET_UPDATE_TASKMAP_NOSTATUS: {
      if (state.TaskMaps.length === 0) return { ...state, TaskMaps: [] };
      let TaskMaps7 = state.TaskMaps;
      const FindTaskMap7 = TaskMaps7.filter(
        (item) => item._id === action.Payload._id,
      );
      const FindTaskMap7Index = TaskMaps7.indexOf(FindTaskMap7[0]);
      if (FindTaskMap7Index < 0) {
        return state;
      }
      TaskMaps7[FindTaskMap7Index] = action.Payload;
      if (
        action.Payload.ChangeStatus &&
        (action.Payload.ChangeStatus === "ParentRemoved" ||
          action.Payload.ChangeStatus === "ParentChanged")
      ) {
        const FindOldParent = TaskMaps7.find(
          (item) => item._id === action.Payload.OldParentID,
        );
        const RemovedChilds = FindOldParent.Childs.filter(
          (item) => item.TaskMapID !== action.Payload._id,
        );
        const TaskMapIndexof = TaskMaps7.indexOf(FindOldParent);
        TaskMaps7[TaskMapIndexof].Childs = RemovedChilds;
      }
      if (
        action.Payload.ChangeStatus &&
        (action.Payload.ChangeStatus === "ParentChanged" ||
          action.Payload.ChangeStatus === "NewChild")
      ) {
        const FindNewParent = TaskMaps7.find(
          (item) => item._id === action.Payload.ParentID,
        );
        const TaskMapIndexof = TaskMaps7.indexOf(FindNewParent);
        TaskMaps7[TaskMapIndexof].Childs.push(action.Payload.ParentChildBody);
      }
      return { ...state, TaskMaps: [...TaskMaps7] };
    }
    case SOCKET_UPDATE_TASK: {
      const payload = action.Payload || {};
      const TaskID = payload.TaskID;
      const Status = payload.Status || "Ready";
      const taskData = payload.data || {};

      if (!TaskID) {
        console.warn("⚠️ No TaskID in SOCKET_UPDATE_TASK payload");
        return state;
      }

      // 🔥 **ایمن‌سازی: همیشه tasks رو چک کن**
      const currentTasks = state.tasks || [];

      // پیدا کردن task
      const taskIndex = currentTasks.findIndex((t) => t._id === TaskID);

      if (taskIndex !== -1) {
        // به‌روزرسانی task موجود
        const updatedTasks = [...currentTasks];
        updatedTasks[taskIndex] = {
          ...updatedTasks[taskIndex],
          ...taskData,
          Status,
          updatedAt: new Date().toISOString(),
        };

        return { ...state, tasks: updatedTasks };
      } else {
        // اضافه کردن task جدید
        return {
          ...state,
          tasks: [
            ...currentTasks,
            {
              _id: TaskID,
              ...taskData,
              Status,
            },
          ],
        };
      }
    }
    case CHANGED_TASKMAP_PRIORITY_SOCKET: {
      const priorityById = new Map(
        action.Payload.map((Back) => [Back._id, Back.Priority]),
      );
      const TaskMaps6 = state.TaskMaps.map((Front) =>
        priorityById.has(Front._id)
          ? { ...Front, Priority: priorityById.get(Front._id) }
          : Front,
      );
      return { ...state, TaskMaps: TaskMaps6 };
    }
    case SOCKET_NEW_TASKMAP: {
      if (
        state.TaskMaps.some((tm) => tm._id === action.Payload?._id) ||
        !action.Payload
      ) {
        return state;
      }
      return {
        Loading: false,
        TaskMaps: [...state.TaskMaps, action.Payload],
      };
    }
    case SOCKET_NEW_TASKMAP_WITH_CHILD: {
      let TaskMaps10 = state.TaskMaps.filter(
        (tm) => tm._id !== action.Payload.ChildBody?._id,
      );
      TaskMaps10 = [...TaskMaps10, action.Payload.ChildBody];
      const FindTaskMap = TaskMaps10.findIndex(
        (item) => item._id === action.Payload.ParentBody._id,
      );
      if (FindTaskMap >= 0) {
        TaskMaps10 = [...TaskMaps10];
        TaskMaps10[FindTaskMap] = action.Payload.ParentBody;
      }
      return { Loading: false, TaskMaps: TaskMaps10 };
    }
    case SOCKET_LEAVE_TASKMAP: {
      return { Loading: false, TaskMaps: [] };
    }
    case IMPORT_TASKMAPS: {
      return { Loading: false, TaskMaps: action.Payload };
    }
    case ADMIN_PERMISSION_TASKMAPS: {
      return {
        ...state,
        TaskMaps: state.TaskMaps.map((TaskMap) => {
          if (TaskMap._id === action.Payload.TaskID) {
            return {
              ...TaskMap,
              IsTaskMapManager: action.Payload.TaskMapManager,
              IsTaskMapQC: action.Payload.TaskMapQC,
            };
          } else return TaskMap;
        }),
      };
    }
    case UPDATE_TASKMAP_TASKDETAIL_GANTT:
      return patchTaskMap(state, action.Payload.TaskMapID, {
        StartTime: action.Payload.body.StartTime,
        DeadLine: action.Payload.body.DeadLine,
      });
    case ADD_FINANTIAL_PAYMENT_TASKMAP:
      return pushTaskMapList(
        state,
        action.Payload.TaskMapID,
        "Payments",
        action.Payload.data,
      );
    case CHANGE_FINANTIAL_PAYMENT_TASKMAP:
      return replaceInTaskMapList(
        state,
        action.Payload.TaskMapID,
        "Payments",
        action.Payload.data,
      );
    case DELETE_FINANTIAL_PAYMENT_TASKMAP:
      return removeFromTaskMapList(
        state,
        action.Payload.TaskMapID,
        "Payments",
        (item) => item._id !== action.Payload.data,
      );
    case NEW_BOARD_TASKMAP_REMINDER:
      return pushTaskMapList(
        state,
        action.Payload.TaskMapID,
        "Reminders",
        action.Payload.data,
      );
    case EDIT_BOARD_TASKMAP_REMINDER:
      return replaceInTaskMapList(
        state,
        action.Payload.TaskMapID,
        "Reminders",
        action.Payload.data,
      );
    case DELETE_BOARD_TASKMAP_REMINDER:
      return removeFromTaskMapList(
        state,
        action.Payload.TaskMapID,
        "Reminders",
        (item) => item._id !== action.Payload.data,
      );
    case NEW_CHECKLIST_TASKMAP_ADD:
      return pushTaskMapList(
        state,
        action.Payload.TaskMapID,
        "TaskMapChecklist",
        action.Payload.body,
      );
    case GET_CHECKLIST_TASKMAP:
    case TASKMAP_CHECKLIST_ORDER_CHANGED:
    case TASKMAP_CHECKLIST_DELETE:
    case TASKMAP_CHECKLIST_STATUS_CHANGED:
      return patchTaskMap(state, action.Payload.TaskMapID, {
        TaskMapChecklist: action.Payload.body,
      });
    case GET_TASKMAP_CHARTER: {
      const TaskMapID = action.Payload.TaskMapID;
      const FindIndexTM19 = state.TaskMaps.findIndex(
        (item) => String(item._id) === String(TaskMapID),
      );
      if (FindIndexTM19 === -1) return state;

      const TaskMaps19 = [...state.TaskMaps];
      TaskMaps19[FindIndexTM19] = {
        ...TaskMaps19[FindIndexTM19],
        Charter: action.Payload.Charter,
      };
      return { ...state, TaskMaps: TaskMaps19 };
    }
    case GET_TASKMAP_DOCUMENTS:
      return patchTaskMap(state, action.Payload.TaskMapID, {
        Documents: action.Payload.Documents,
      });
    case GET_TASKMAP_MEETING_MINUTES:
      return patchTaskMap(state, action.Payload.TaskMapID, {
        MeetingMinutes: action.Payload.MeetingMinutes,
      });
    case GET_TASKMAP_RESOURCES:
      return patchTaskMap(state, action.Payload.TaskMapID, {
        Resources: action.Payload.Resources,
      });
    case GET_TASKMAP_RESOURCES_BUYLIST:
      return patchTaskMap(state, action.Payload.TaskMapID, {
        ResourcesBuyLists: action.Payload.ResourcesBuyLists,
      });
    case GET_TASKMAP_CORRESPONDENCE:
      return patchTaskMap(state, action.Payload.TaskMapID, {
        Correspondences: action.Payload.Correspondences,
      });
    case REMOVE_TASKMAP_MEMBER_SUCCESS:
      return patchTaskMap(state, action.TaskMapID, {
        TaskMapMembers: action.Payload,
      });
    default: {
      return state;
    }
  }
};

export const GetTaskDetailReducer = (
  state = { Desc: "", Payments: [] },
  action,
) => {
  switch (action.type) {
    case GET_TASKDESC_SUCCESS: {
      return { ...state, Desc: action.Payload };
    }
    case GET_TASK_PAYMENTS_SUCCESS: {
      return { ...state, Payments: action.Payload };
    }
    case ADD_FINANTIAL_PAYMENT: {
      return { ...state, Payments: [...state.Payments, action.Payload] };
    }
    case CHANGE_FINANTIAL_PAYMENT_TASK: {
      let Payments1 = state.Payments;
      const FindPayment = Payments1.filter(
        (item) => item._id === action.Payload._id,
      );
      const FindIndex1 = Payments1.indexOf(FindPayment[0]);
      Payments1[FindIndex1] = action.Payload;
      return { ...state, Payments: [...Payments1] };
    }
    case DELETE_FINANTIAL_PAYMENT_TASK: {
      let Payments2 = state.Payments;
      const Removed2 = Payments2.filter((item) => item._id !== action.Payload);
      return { ...state, Payments: [...Removed2] };
    }
    default: {
      return state;
    }
  }
};

export const GetTaskMapMemberReducer = (
  state = { Loading: true, member: [], checklist: [] },
  action,
) => {
  switch (action.type) {
    case GET_TASKMAPMEMBER_REQUEST: {
      return { Loading: true, member: [] };
    }
    case GET_TASKMAPMEMBER_SUCCESS: {
      return { Loading: false, member: action.Payload };
    }
    case REMOVE_TASKMAP_MEMBER_SUCCESS: {
      return { Loading: false, member: action.Payload };
    }
    // case TASKMAP_CHECKLIST_GET:
    //   let Sorted = [...action.Payload].sort((a, b) => a.Order - b.Order);
    //   return { Loading: false, checklist: Sorted };
    // case NEW_CHECKLIST_TASKMAP_ADD:
    //   let Checklist = state.checklist;
    //   Checklist.push(action.Payload);
    //   Checklist = [...new Set(Checklist)];
    //   Checklist = [...Checklist].sort((a, b) => a.Order - b.Order);
    //   return { Loading: false, checklist: Checklist };
    // case TASKMAP_CHECKLIST_ORDER_CHANGED:
    //   let SortedChecklist = [...action.Payload].sort(
    //     (a, b) => a.Order - b.Order
    //   );
    //   return { Loading: false, checklist: SortedChecklist };
    // case TASKMAP_CHECKLIST_DELETE:
    //   let SortedChecklistofDelete = [...action.Payload].sort(
    //     (a, b) => a.Order - b.Order
    //   );
    //   return { Loading: false, checklist: SortedChecklistofDelete };
    // case TASKMAP_CHECKLIST_STATUS_CHANGED:
    //   let SortedChecklistofStatusChng = [...action.Payload].sort(
    //     (a, b) => a.Order - b.Order
    //   );
    //   return { Loading: false, checklist: SortedChecklistofStatusChng };
    default: {
      return state;
    }
  }
};
export const GetBoardNameReducer = (
  state = {
    Loading: false,
    BoardName: "",
    BoardPic: undefined,
    MenuModel: "",
    ViewSprintMood: false,
    SprintMoodData: {},
    Permission: false,
    Permissions: {},
    UGPermissions: {},
    Plan: [],
    Setting: {
      Appearance: {
        SubTasks_SortbyDeadLine: true,
      },
    },
    ProjectTemporaryGolas: [],
    Automations: [],
    Columns: [],
    DeletedCol: "",
    MemberRates: [],
    MemberTimes: [],
    WorkDailyReports: [],
    WorkRecentReports: [],
    AdvocacyReviewRuns: null,
    AdvocacyReviewDay: null,
    WorkingTimeID: "",
    WorkingTimeStatus: false,
    PomodoroState: null,
    OnlineTimeID: "",
    OnlineUsers: [],
    UserFreeBoards: 0,
    BoardSize: {},
    TaskCategories: [],
    TaskFilters: {},
    SprintFilters: {},
    FilterShowAll: true,
    TasksWithDetail: false,
    TasksViewModel: "Kanban",
    TaskSearchText: "",
    Discount: {},
    NewUserDiscount: {},
    UploadScreenStatus: false,
    FullScreenCalendar: false,
    CalendarShowingTime: undefined,
    CalendarShowingMood: undefined,
    CalendarShowLoopsBody: {},
    BoardParent: {},
    BoardMainParent: {},
    BoardHistory: [],
    BoardUserHistory: [],
    PrivacyMood: "Private",
    AnonymousUserPermissions: {},
    ShowingCosID: "Default",
  },
  action,
) => {
  switch (action.type) {
    case GET_BOARD_HISTORY: {
      return {
        ...state,
        BoardHistory: action.Payload ?? [],
      };
    }
    case GET_BOARD_USER_HISTORY: {
      return {
        ...state,
        BoardUserHistory: action.Payload ?? [],
      };
    }
    case GET_BOARD_GENERAL_DATA: {
      return {
        ...state,
        Loading: false,
        BoardName: action.Payload.name || undefined,
        BoardPic: action.Payload.Pic || undefined,
        BoardParent: action.Payload.Parent || {},
        BoardMainParent: action.Payload.MainParent || {},
        AnonymousUserPermissions:
          action.Payload.AnonymousUserPermissions || undefined,
        PrivacyMood: action.Payload.PrivacyMood || undefined,

        // BoardSize: {
        //   FinalSize: action.Payload.FinalSize,
        //   BoardSizeLimit: action.Payload.BoardSizeLimit
        // },
        // Setting: action.Payload.Setting,
        // Permission: action.Payload.AdminOwnerStatus,
        // Permissions: action.Payload.FinalPermisions,
        // Plan: action.Payload.Plan,
        // Columns: action.Payload.BoardColumns
      };
    }
    case BOARD_PIC: {
      return { ...state, BoardPic: action.Payload };
    }
    case GET_BOARD_NAME_REQUEST: {
      return { ...state, Loading: true, BoardName: "" };
    }
    case GET_BOARD_NAME_SUCCESS: {
      return {
        ...state,
        Loading: false,
        BoardName: action.Payload,
      };
    }
    case CALENDAR_SHOW_LOOP_TASKS: {
      return {
        ...state,
        CalendarShowLoopsBody: action.Payload,
      };
    }
    case BOARD_MENU_MODEL: {
      return { ...state, MenuModel: action.Payload };
    }
    case TOGGLE_FULLSCREEN_CALENDAR: {
      return { ...state, FullScreenCalendar: !state.FullScreenCalendar };
    }
    case TOOGLE_SHOW_SPRINT_MOOD: {
      return {
        ...state,
        ViewSprintMood: !state.ViewSprintMood,
      };
    }
    case SPRINT_MOOD_DATA: {
      return {
        ...state,
        SprintMoodData: action.Payload,
      };
    }
    case SET_CALENDAR_ACTIVE_TIME: {
      return { ...state, CalendarShowingTime: action.Payload };
    }
    case SET_CALENDAR_SHOWING_MOOD: {
      return { ...state, CalendarShowingMood: action.Payload };
    }
    case BOARD_ADMIN_OWNER_CHECK: {
      return {
        ...state,
        Permission: action.Payload.Status,
      };
    }
    case BOARD_PERMISSIONS: {
      return {
        ...state,
        Permissions: action.Payload,
      };
    }
    case UG_PERMISSIONS: {
      return {
        ...state,
        UGPermissions: action.Payload,
      };
    }
    case GET_BOARD_PANEL: {
      return {
        ...state,
        Plan: action.Payload,
      };
    }
    case GET_BOARD_SETTING: {
      return {
        ...state,
        Setting: action.Payload,
      };
    }
    case GET_BOARDTEMPORARY_GOALS: {
      return {
        ...state,
        ProjectTemporaryGolas: action.Payload,
      };
    }
    case GET_BOARD_WORK_SETTING: {
      const Setting1 = state.Setting;
      Setting1.WorkSettings = action.Payload;
      return {
        ...state,
        Setting: Setting1,
      };
    }
    case GET_BOARD_AUTOMATIONS_SUCCESS: {
      return {
        ...state,
        Automations: action.Payload,
      };
    }
    case Delete_BOARD_COLUMN_SOCKET: {
      return {
        ...state,
        DeletedCol: action.Payload,
      };
    }
    case GET_BOARD_COLUMNS: {
      return { ...state, Columns: action.Payload };
    }
    case GET_USER_RATES: {
      return { ...state, MemberRates: action.Payload };
    }
    case ADD_USER_RATES: {
      return {
        ...state,
        MemberRates: {
          ...state.MemberRates,
          FinalUserRates: action.Payload,
        },
      };
    }
    case GET_USER_TIMES: {
      return { ...state, MemberTimes: action.Payload };
    }
    case USER_DAILY_WORK_REPORTS: {
      return { ...state, WorkDailyReports: action.Payload };
    }
    case USER_RECENT_WORK_REPORTS: {
      return { ...state, WorkRecentReports: action.Payload };
    }
    case ADVOCACY_REVIEW_RUNS_SUCCESS: {
      return { ...state, AdvocacyReviewRuns: action.Payload };
    }
    case ADVOCACY_REVIEW_DAY_SUCCESS: {
      return { ...state, AdvocacyReviewDay: action.Payload };
    }
    case USER_WORKING_TIME_ID: {
      return { ...state, WorkingTimeID: action.Payload };
    }
    case USER_ONLINE_TIME_ID: {
      return { ...state, OnlineTimeID: action.Payload };
    }
    case GET_ONLINE_USERS: {
      const OnlineUsersServers = [
        ...new Map(action.Payload.map((m) => [m._id, m])).values(),
      ];
      return { ...state, OnlineUsers: OnlineUsersServers };
    }
    case USER_CONNECT_BOARDROOM: {
      if (!action.Payload?._id) return state;
      const merged = new Map((state.OnlineUsers || []).map((m) => [m._id, m]));
      merged.set(action.Payload._id, action.Payload);
      return { ...state, OnlineUsers: [...merged.values()] };
    }
    case USER_LEAVE_BOARDROOM: {
      const leaveId = action.Payload != null ? String(action.Payload) : null;
      if (!leaveId) return state;
      const OnlineUsers = (state.OnlineUsers || []).filter(
        (e) => e && String(e._id) !== leaveId,
      );
      return { ...state, OnlineUsers };
    }
    case USER_WORKING_STATUS: {
      const userId =
        action.Payload?.UserID != null ? String(action.Payload.UserID) : null;
      if (!userId) return state;
      const idx = (state.OnlineUsers || []).findIndex(
        (e) => e && String(e._id) === userId,
      );
      if (idx < 0) return state;
      const OnlineUsers = [...state.OnlineUsers];
      OnlineUsers[idx] = {
        ...OnlineUsers[idx],
        IsWorking: action.Payload.IsWorking,
      };
      return { ...state, OnlineUsers };
    }
    case CHANGE_CURRENT_USER_WORKING_STATUS: {
      return { ...state, WorkingTimeStatus: action.Payload };
    }
    case SET_POMODORO_STATE: {
      return { ...state, PomodoroState: action.Payload };
    }
    case NUMBER_FREE_JOINED_BOARD: {
      return { ...state, UserFreeBoards: action.Payload };
    }
    case BOARD_SIZE_LIMIT_SERVER: {
      return { ...state, BoardSize: action.Payload };
    }
    case NEW_CATEGORY_TASK: {
      return { ...state, TaskCategories: action.Payload };
    }
    case TASKS_FILTERS_DATA: {
      return {
        ...state,
        TaskFilters: action.Payload,
      };
    }
    case SPRINT_FILTERS_DATA: {
      return {
        ...state,
        SprintFilters: action.Payload,
      };
    }
    case TASKS_SHOW_ALL_FILTER: {
      return {
        ...state,
        FilterShowAll: action.Payload,
      };
    }
    case TASKS_SHOW_DETAIL_TOGGLE: {
      return {
        ...state,
        TasksWithDetail: action.Payload,
      };
    }
    case TASKS_VIEW_MODEL: {
      return {
        ...state,
        TasksViewModel: action.Payload,
      };
    }
    case TASKS_SEARCH_TEXT: {
      return {
        ...state,
        TaskSearchText: action.Payload,
      };
    }
    case DISCOUNT_CODE_CHECK: {
      return {
        ...state,
        Discount: action.Payload,
      };
    }
    case NEW_USER_DISCOUNT_STATUS: {
      return {
        ...state,
        NewUserDiscount: action.Payload,
      };
    }
    case CHANGE_UPLOAD_WORKED_SCREEN_STATUS: {
      return {
        ...state,
        UploadScreenStatus: action.Payload,
      };
    }
    default: {
      return state;
    }
  }
};

export const BoardToggleDisplay = (
  Loading = {
    Channel: false,
    Team: false,
    Setting: false,
    AiStudio: false,
    DailyReport: false,
    WorkingScreenCheck: false,
    ArchivedTasks: false,
    Calender: false,
    WBS: false,
    WhiteSpace: false,
    FlowChart: false,
    Financial: false,
    Resources: false,
    CRM: false,
    Crisis: false,
    Reminder: false,
    Habits: false,
    Charter: false,
    Documentation: false,
    AdvocacyReview: false,
    MeetingMinutes: false,
    Correspondence: false,
    Form: false,
    Layout: "ListHerozental",
  },
  action,
) => {
  switch (action.type) {
    case TOGGLE_SHOW_BOARD_CHENNEL: {
      return {
        ...Loading,
        Channel: !Loading.Channel,
      };
    }
    case TOGGLE_SHOW_BOARD_TEAM: {
      return {
        ...Loading,
        Team: !Loading.Team,
      };
    }
    case TOGGLE_SHOW_BOARD_SETTING: {
      return {
        ...Loading,
        Setting: !Loading.Setting,
      };
    }
    case TOGGLE_SHOW_BOARD_AISTUDIO: {
      return {
        ...Loading,
        AiStudio: !Loading.AiStudio,
      };
    }
    case TOGGLE_SHOW_BOARD_MEETING_MINUTE: {
      return {
        ...Loading,
        MeetingMinutes: !Loading.MeetingMinutes,
      };
    }
    case TOGGLE_SHOW_BOARD_CORRESPONDENCE: {
      return {
        ...Loading,
        Correspondence: !Loading.Correspondence,
      };
    }
    case TOGGLE_SHOW_BOARD_ARCHIVED_TASKS: {
      return {
        ...Loading,
        ArchivedTasks: !Loading.ArchivedTasks,
      };
    }
    case TOGGLE_SHOW_DAILY_REPORT: {
      return {
        ...Loading,
        DailyReport: !Loading.DailyReport,
      };
    }
    case TOGGLE_SHOW_REMINDER: {
      return {
        ...Loading,
        Reminder: !Loading.Reminder,
      };
    }
    case TOGGLE_SHOW_BOARD_HABITS: {
      return {
        ...Loading,
        Habits: !Loading.Habits,
      };
    }
    case TOOGLE_SHOW_SCREEN_CHECK: {
      return {
        ...Loading,
        WorkingScreenCheck: !Loading.WorkingScreenCheck,
      };
    }
    case TOOGLE_SHOW_CALENDER_CHECK: {
      return {
        ...Loading,
        Calender: !Loading.Calender,
      };
    }
    case TOGGLE_SHOW_BOARD_FINANCIAL: {
      return {
        ...Loading,
        Financial: !Loading.Financial,
      };
    }
    case TOGGLE_SHOW_BOARD_RESOURCES: {
      return {
        ...Loading,
        Resources: !Loading.Resources,
      };
    }
    case TOGGLE_SHOW_CRM: {
      return {
        ...Loading,
        CRM: !Loading.CRM,
      };
    }
    case TOGGLE_SHOW_CRISIS: {
      return {
        ...Loading,
        Crisis: !Loading.Crisis,
      };
    }
    case TOGGLE_SHOW_BOARD_CHARTER: {
      return {
        ...Loading,
        Charter: !Loading.Charter,
      };
    }
    case TOOGLE_SHOW_WBS_CHECK: {
      return {
        ...Loading,
        WBS: !Loading.WBS,
      };
    }
    case TOGGLE_SHOW_BOARD_WHITE_SPACE: {
      return {
        ...Loading,
        WhiteSpace: !Loading.WhiteSpace,
      };
    }
    case TOGGLE_SHOW_BOARD_FLOW_CHART: {
      return {
        ...Loading,
        FlowChart: !Loading.FlowChart,
      };
    }
    case TOGGLE_SHOW_BOARD_DOCUMENTATION: {
      return {
        ...Loading,
        Documentation: !Loading.Documentation,
      };
    }
    case TOGGLE_SHOW_BOARD_ADVOCACY_REVIEW: {
      return {
        ...Loading,
        AdvocacyReview: !Loading.AdvocacyReview,
      };
    }
    case SET_SHOW_BOARD_ADVOCACY_REVIEW: {
      return {
        ...Loading,
        AdvocacyReview: Boolean(action.payload),
      };
    }
    case TOGGLE_SHOW_BOARD_FORM: {
      return {
        ...Loading,
        Form: !Loading.Form,
      };
    }
    case BOARD_TASK_LAYOUT: {
      return {
        ...Loading,
        Layout: action.Payload,
      };
    }
    default: {
      return Loading;
    }
  }
};
export const BoardTeamToggleReducer = (
  state = {
    Loading: true,
    data: [],
    Groups: [],
    removedIDs: [],
    AddItems: [],
    UserGroups: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_BOARD_USERS_SUCCESS: {
      return {
        ...state,
        Loading: false,
        data: action.Payload,
      };
    }
    case GET_BOARD_GROUPS: {
      return { ...state, Groups: action.Payload };
    }
    case GET_USER_BOARD_GROUPS: {
      return { ...state, UserGroups: action.Payload };
    }
    case TOGGLE_ADMIN_SUCCESS: {
      return {
        ...state,
        data: state.data.map((item) => {
          if (item._id === action.Payload.ID) {
            return {
              ...item,
              IsAdmin: action.Payload.Status,
            };
          } else return item;
        }),
      };
    }
    case REMOVE_BOARD_MEMBER_SUCCESS: {
      return {
        ...state,
        removedIDs: action.Payload,
      };
    }
    case EMPTY_NEW_REMOVED_MEMBER_MEMBER_STATE: {
      return {
        ...state,
        removedIDs: undefined,
      };
    }
    case ADD_NEW_BOARD_USERS_SUCCESS: {
      return {
        ...state,
        AddItems: [...state.AddItems, action.Payload],
      };
    }
    case EDIT_BOARD_MEMBER_SUCCESS: {
      const Members1 = state.data;
      const FindUser1 = Members1.find(
        (item) => item._id === action.Payload._id,
      );
      const index1 = Members1.indexOf(FindUser1);

      Members1[index1] = action.Payload;

      return {
        ...state,
        data: Members1,
      };
    }
    case ADD_BOARD_GROUPS: {
      return { ...state, Groups: [...state.Groups, action.Payload] };
    }
    case EDIT_BOARD_GROUP: {
      let data1 = state.Groups;

      const FindGroup1 = data1.find((item) => item._id === action.Payload._id);
      const IndexGroup1 = data1.indexOf(FindGroup1);

      data1[IndexGroup1] = action.Payload;

      return { ...state, Groups: [...data1] };
    }
    case DELETE_BOARD_GROUP: {
      let data2 = state.Groups;

      const Filter2 = data2.filter((item) => item._id !== action.Payload);

      return { ...state, Groups: [...Filter2] };
    }
    default: {
      return state;
    }
  }
};

export const BoardFinancialReducer = (
  state = {
    Loading: true,
    data: [],
    Categories: [],
    PaymentsArr: [],
    TasksPaymentsArr: [],
  },
  action,
) => {
  switch (action.type) {
    case GET_BOARD_FINANCIAL: {
      return {
        ...state,
        Loading: false,
        data: action.Payload,
      };
    }
    case GET_BOARD_FINANCIAL_PAYMENTS: {
      return {
        ...state,
        Loading: false,
        PaymentsArr: action.Payload,
      };
    }
    case GET_BOARD_FINANCIAL_PAYMENTS_TASKS: {
      return {
        ...state,
        Loading: false,
        TasksPaymentsArr: action.Payload,
      };
    }
    case FINANCIAL_CATEGORY_CHANGE: {
      let data1 = state.data;
      data1.Categories = action.Payload;

      return { ...state, data: data1 };
    }
    case FINANCIAL_PAYMENT_CATEGORY_CHANGE: {
      let data2 = state.data;
      data2.PaymentType = action.Payload;

      return { ...state, data: data2 };
    }
    case FINANCIAL_SETTINGS_CHANGE: {
      let data3 = state.data;
      data3.Settings = action.Payload;

      return { ...state, data: data3 };
    }
    case FINANCIAL_BUDGET_CHANGE: {
      let dataB = state.data;
      dataB.Budget = action.Payload;

      return { ...state, data: dataB };
    }
    case FINANCIAL_CATEGORIES: {
      return { ...state, Categories: action.Payload };
    }
    case NEW_FINANTIAL_PAYMENT: {
      let data5 = state.PaymentsArr;
      data5.push(action.Payload);

      return { ...state, PaymentsArr: [...data5] };
    }
    case UPDATED_FINANTIAL_PAYMENT: {
      let data4 = state.PaymentsArr;
      const FindPayment = data4.filter(
        (item) => item._id === action.Payload._id,
      );

      const FindIndex4 = data4.indexOf(FindPayment[0]);

      data4[FindIndex4] = action.Payload;

      return { ...state, PaymentsArr: [...data4] };
    }
    case DELETE_FINANTIAL_PAYMENT: {
      let data6 = state.PaymentsArr;

      let Payments = data6;
      Payments = Payments.filter((item) => item._id !== action.Payload);

      data6 = Payments;

      return { ...state, PaymentsArr: [...data6] };
    }
    case DELETE_FINANTIAL_PAYMENT_TASK_ALL: {
      let data8 = state.TasksPaymentsArr;

      let Find8 = data8.filter((item) => item.TaskID === action.Payload.TaskID);
      Find8 = Find8[0];
      const FindIndex8 = data8.indexOf(Find8);

      let Removed = Find8.TaskPayments.filter(
        (item) => item._id !== action.Payload.data,
      );

      Find8.TaskPayments = Removed;

      data8[FindIndex8] = Find8;

      return { ...state, TasksPaymentsArr: [...data8] };
    }
    case CHANGE_FINANTIAL_PAYMENT_TASK_ALL: {
      let data10 = state.TasksPaymentsArr;

      let Find10 = data10.filter(
        (item) => item.TaskID === action.Payload.TaskID,
      );
      Find10 = Find10[0];
      const FindIndex10 = data10.indexOf(Find10);

      let FindPayment10 = Find10.TaskPayments.filter(
        (item) => item._id === action.Payload.data._id,
      );

      const FindPaymentIndex10 = Find10.TaskPayments.indexOf(FindPayment10[0]);

      Find10.TaskPayments[FindPaymentIndex10] = action.Payload.data;

      data10[FindIndex10] = Find10;

      return { ...state, TasksPaymentsArr: [...data10] };
    }
    case DELETE_FINANTIAL_PAYMENT_TASKMAP_ALL: {
      const data9 = [...state.TasksPaymentsArr];
      const FindIndex9 = data9.findIndex(
        (item) => item.TaskID === action.Payload.TaskID,
      );
      if (FindIndex9 < 0) return state;

      const taskMaps9 = [...data9[FindIndex9].TaskMaps];
      const FindTMIndex9 = taskMaps9.findIndex(
        (item) => item.TaskMapID === action.Payload.TaskMapID,
      );
      if (FindTMIndex9 < 0) return state;

      taskMaps9[FindTMIndex9] = {
        ...taskMaps9[FindTMIndex9],
        Payments: taskMaps9[FindTMIndex9].Payments.filter(
          (item) => item._id !== action.Payload.data,
        ),
      };

      data9[FindIndex9] = { ...data9[FindIndex9], TaskMaps: taskMaps9 };

      return { ...state, TasksPaymentsArr: data9 };
    }
    case CHANGE_FINANTIAL_PAYMENT_TASKMAP_ALL: {
      let data11 = state.TasksPaymentsArr;

      let Find11 = data11.filter(
        (item) => item.TaskID === action.Payload.TaskID,
      );
      Find11 = Find11[0];

      const FindIndex11 = data11.indexOf(Find11);

      let FindTaskMap11 = Find11.TaskMaps.filter(
        (item) => item.TaskMapID === action.Payload.TaskMapID,
      );
      const FindTMIndex11 = Find11.TaskMaps.indexOf(FindTaskMap11[0]);

      let FindTaskMapPayment = FindTaskMap11[0].Payments.filter(
        (item) => item._id === action.Payload.data._id,
      );

      const FindTMPaymentIndex11 = Find11.TaskMaps[
        FindTMIndex11
      ].Payments.indexOf(FindTaskMapPayment[0]);

      Find11.TaskMaps[FindTMIndex11].Payments[FindTMPaymentIndex11] =
        action.Payload.data;

      data11[FindIndex11] = Find11;

      return { ...state, TasksPaymentsArr: [...data11] };
    }
    case FINANTIAL_DUE_PERCENTAGE_CHANGE: {
      let data7 = state.data;
      data7.DuePercentage = action.Payload;

      return { ...state, data: data7 };
    }
    default: {
      return state;
    }
  }
};
export const UploadManagerReducer = (
  state = { data: [], TaskDefineRecordedVoice: undefined, multiVoiceArr: [] },
  action,
) => {
  switch (action.type) {
    case SET_UPLOADS: {
      return { ...state, data: action.Payload };
    }
    case ADD_UPLOAD: {
      if (action.inMultiVoice) {
        return {
          ...state,
          multiVoiceArr: [
            ...state.multiVoiceArr,
            {
              ...action.Payload,
              whereID: action.whereID || undefined,
            },
          ],
        };
      }

      if (action.which && action.which === "TaskDefineVoice") {
        console.log(
          "[Redux Reducer] Setting TaskDefineRecordedVoice:",
          action.Payload,
        );
        return {
          ...state,
          TaskDefineRecordedVoice: {
            ...action.Payload,
            whereID: action.whereID || undefined,
          },
        };
      }
      return { ...state, data: [...state.data, action.Payload] };
    }

    case DELETE_UPLOAD: {
      let data1 = state.data;
      data1 = data1.filter((item) => item.meta.id !== action.Payload);
      return { ...state, data: data1 };
    }

    case DELETE_MULTI_VOICE_UPLOAD: {
      const payload = action.Payload;
      const id = typeof payload === "string" ? payload : payload?.id;
      const whereID =
        typeof payload === "string" ? undefined : payload?.whereID;

      if (!id) return state;

      const filtered = state.multiVoiceArr.filter((item) => {
        const itemId = item?.meta?.id || item?._id || item?.url;
        if (itemId !== id) return true;

        // if whereID was provided, only delete the item in that scope
        if (whereID !== undefined && item?.whereID !== whereID) return true;

        return false;
      });

      return { ...state, multiVoiceArr: filtered };
    }

    case DELETE_ALL_UPLOAD: {
      return {
        ...state,
        data: [],
        TaskDefineRecordedVoice: undefined,
        multiVoiceArr: [],
      };
    }
    default: {
      return state;
    }
  }
};

export const BoardReminderReducer = (
  state = { Reminders: [], TaskReminders: [], AllTasksReminders: [] },
  action,
) => {
  switch (action.type) {
    case GET_BOARD_REMINDER: {
      return { ...state, Reminders: action.Payload };
    }
    case NEW_BOARD_REMINDER: {
      return { ...state, Reminders: [...state.Reminders, action.Payload] };
    }
    case EDIT_BOARD_REMINDER: {
      const data1 = state.Reminders;
      const Find1 = data1.find((item) => item._id === action.Payload._id);
      const indexOfFind1 = data1.indexOf(Find1);
      data1[indexOfFind1] = action.Payload;
      return { ...state, Reminders: [...data1] };
    }
    case DELETE_BOARD_REMINDER: {
      const Find2 = state.Reminders.filter(
        (item) => item._id !== action.Payload,
      );
      return { ...state, Reminders: [...Find2] };
    }
    case GET_BOARD_TASK_REMINDERS: {
      return { ...state, TaskReminders: action.Payload };
    }
    case GET_BOARD_TASKS_REMINDERS: {
      return { ...state, AllTasksReminders: action.Payload };
    }
    case NEW_BOARD_TASK_REMINDER: {
      return {
        ...state,
        TaskReminders: [...state.TaskReminders, action.Payload],
      };
    }
    case EDIT_BOARD_TASK_REMINDER: {
      const data3 = state.TaskReminders;
      const Find3 = data3.find((item) => item._id === action.Payload._id);
      const indexOfFind3 = data3.indexOf(Find3);
      data3[indexOfFind3] = action.Payload;
      return { ...state, TaskReminders: [...data3] };
    }
    case DELETE_BOARD_TASK_REMINDER: {
      const Find4 = state.TaskReminders.filter(
        (item) => item._id !== action.Payload,
      );
      return { ...state, TaskReminders: [...Find4] };
    }
    default: {
      return state;
    }
  }
};

export const ProgressChartReducer = (
  state = {
    totalTasks: 0,
    completedTasks: 0,
    firstTaskTime: null,
    lastTaskTime: null,
    totalTaskMaps: 0,
    completedTaskMaps: 0,
    firstTaskMapTime: null,
    lastTaskMapTime: null,
  },
  action,
) => {
  switch (action.type) {
    case GET_PROGRESS_CHART_DATA:
      return {
        ...state,
        totalTasks: action.Payload.totalTasks,
        completedTasks: action.Payload.completedTasks,
        firstTaskTime: action.Payload.firstTaskTime,
        lastTaskTime: action.Payload.lastTaskTime,
      };

    case GET_TASKMAPS_PROGRESS_CHART_DATA:
      return {
        ...state,
        totalTaskMaps: action.Payload.totalTaskMaps,
        completedTaskMaps: action.Payload.completedTaskMaps,
        firstTaskMapTime: action.Payload.firstTaskMapTime,
        lastTaskMapTime: action.Payload.lastTaskMapTime,
      };

    default:
      return state;
  }
};

const upsertCurrentDoing = (
  tasks,
  currentByTaskID,
  rawTaskId,
  rawCurrentDoing,
) => {
  const TaskID = String(rawTaskId ?? "");
  const CurrentDoing = rawCurrentDoing || "None";
  let found = false;
  const currentTasks = Array.isArray(tasks) ? tasks : [];
  const nextTasks = currentTasks.map((task) => {
    if (String(task.TaskID) !== TaskID) return task;
    found = true;
    return { ...task, TaskID, CurrentDoing };
  });

  if (!found) nextTasks.push({ TaskID, CurrentDoing });

  const nextByTaskID = {
    ...(currentByTaskID || {}),
    [TaskID]: CurrentDoing,
  };

  return { Tasks: nextTasks, ByTaskID: nextByTaskID };
};

export const CurrentDoingReducer = (
  state = { Tasks: [], ByTaskID: {} },
  action,
) => {
  switch (action.type) {
    case GET_TASK_CURRENT_DOING: {
      const { TaskID, CurrentDoing } = action.Payload || {};
      return {
        ...state,
        ...upsertCurrentDoing(
          state.Tasks,
          state.ByTaskID,
          TaskID,
          CurrentDoing,
        ),
      };
    }

    case EDIT_TASK_CURRENT_DOING: {
      const { TaskID: editTaskID, data = {} } = action.Payload || {};
      return {
        ...state,
        ...upsertCurrentDoing(
          state.Tasks,
          state.ByTaskID,
          editTaskID,
          data.CurrentDoing,
        ),
      };
    }

    default:
      return state;
  }
};

export const TaskMapCurrentDoingReducer = (
  state = { SubTasks: [] },
  action,
) => {
  switch (action.type) {
    case GET_TASK_MAP_CURRENT_DOING: {
      const TaskID = String(action.Payload.TaskID ?? "");
      const TaskMapID = String(action.Payload.TaskMapID ?? "");
      const { CurrentDoing } = action.Payload;
      const existingSubTask = state.SubTasks.find(
        (subTask) =>
          String(subTask.TaskID) === TaskID &&
          String(subTask.TaskMapID) === TaskMapID,
      );
      const updatedSubTasksGet = existingSubTask
        ? state.SubTasks.map((subTask) =>
            String(subTask.TaskID) === TaskID &&
            String(subTask.TaskMapID) === TaskMapID
              ? { ...subTask, TaskID, TaskMapID, CurrentDoing }
              : subTask,
          )
        : [
            ...state.SubTasks,
            { TaskID, TaskMapID, CurrentDoing: CurrentDoing || "None" },
          ];
      return { ...state, SubTasks: updatedSubTasksGet };
    }

    case UPDATE_TASK_MAP_CURRENT_DOING: {
      const {
        TaskID: rawUpdateTaskID,
        TaskMapID: rawUpdateTaskMapID,
        data,
      } = action.Payload;
      const updateTaskID = String(rawUpdateTaskID ?? "");
      const updateTaskMapID = String(rawUpdateTaskMapID ?? "");
      const updatedSubTasksEdit = state.SubTasks.map((subTask) =>
        String(subTask.TaskID) === updateTaskID &&
        String(subTask.TaskMapID) === updateTaskMapID
          ? { ...subTask, CurrentDoing: data.CurrentDoing }
          : subTask,
      );
      if (
        !updatedSubTasksEdit.find(
          (subTask) =>
            String(subTask.TaskID) === updateTaskID &&
            String(subTask.TaskMapID) === updateTaskMapID,
        )
      ) {
        updatedSubTasksEdit.push({
          TaskID: updateTaskID,
          TaskMapID: updateTaskMapID,
          CurrentDoing: data.CurrentDoing || "None",
        });
      }
      return { ...state, SubTasks: updatedSubTasksEdit };
    }

    case FORM_ATTENTION_CHANGED: {
      return {
        ...state,
        socketSignals: {
          ...state.socketSignals,
          formAttentionChanged: action.Payload,
        },
      };
    }
    case BOARD_ROOM_CHANGED: {
      return {
        ...state,
        socketSignals: {
          ...state.socketSignals,
          boardRoomChanged: action.Payload,
        },
      };
    }
    case SET_SHOWING_COS_ID: {
      return { ...state, ShowingCosID: action.Payload };
    }

    default:
      return state;
  }
};
